/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query'
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query'
import { mutationOptionsWithInteraction } from '../../mutationOptions'
import { customInstance } from '../../mutator'
import type {
  AffectedAnchorDataDTO,
  HTTPValidationError,
  PartialStiffeningIntervalDTOInput,
} from '../fastAPI.schemas'

/**
 * Preview, without saving: the manual loads, comments and picks on Zuganker,
and the Schubverbinder picked by hand, that posting this proposal to
`/stiffening-proposal` would delete.
 * @summary Get Anchor Data Lost By Stiffening Proposal
 */
export const getAnchorDataLostByStiffeningProposal = (
  projectGuid: string,
  partialStiffeningIntervalDTOInput: PartialStiffeningIntervalDTOInput[],
  signal?: AbortSignal,
) => {
  return customInstance<AffectedAnchorDataDTO>({
    url: `/projects/${projectGuid}/stiffening-proposal/affected-anchor-data`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: partialStiffeningIntervalDTOInput,
    signal,
  })
}

export const useGetAnchorDataLostByStiffeningProposalMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAnchorDataLostByStiffeningProposal>>,
    TError,
    { projectGuid: string; data: PartialStiffeningIntervalDTOInput[] },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAnchorDataLostByStiffeningProposal>>,
  TError,
  { projectGuid: string; data: PartialStiffeningIntervalDTOInput[] },
  TContext
> => {
  const mutationKey = ['getAnchorDataLostByStiffeningProposal']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAnchorDataLostByStiffeningProposal>>,
    { projectGuid: string; data: PartialStiffeningIntervalDTOInput[] }
  > = props => {
    const { projectGuid, data } = props ?? {}

    return getAnchorDataLostByStiffeningProposal(projectGuid, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/stiffening-proposal/affected-anchor-data` },
    {
      operationId:
        'get_anchor_data_lost_by_stiffening_proposal_projects__project_guid__stiffening_proposal_affected_anchor_data_post',
      operationName: 'getAnchorDataLostByStiffeningProposal',
    },
  )

  return customOptions
}

export type GetAnchorDataLostByStiffeningProposalMutationResult = NonNullable<
  Awaited<ReturnType<typeof getAnchorDataLostByStiffeningProposal>>
>
export type GetAnchorDataLostByStiffeningProposalMutationBody = PartialStiffeningIntervalDTOInput[]
export type GetAnchorDataLostByStiffeningProposalMutationError = HTTPValidationError

/**
 * @summary Get Anchor Data Lost By Stiffening Proposal
 */
export const useGetAnchorDataLostByStiffeningProposal = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAnchorDataLostByStiffeningProposal>>,
    TError,
    { projectGuid: string; data: PartialStiffeningIntervalDTOInput[] },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof getAnchorDataLostByStiffeningProposal>>,
  TError,
  { projectGuid: string; data: PartialStiffeningIntervalDTOInput[] },
  TContext
> => {
  const mutationOptions = useGetAnchorDataLostByStiffeningProposalMutationOptions(options)

  return useMutation(mutationOptions)
}
